module.exports = {
  change: 'Ändra',
  documents: {
    icon: {
      errorText: 'Du måste välja något från listan!',
    },
    files: {
      removeConfirmTitle: 'Ta bort dokumentet',
      removeConfirmText: 'Är du säker på att du vill ta bort',
      saveConfirmTitle: 'Rensa läshistoriken',
      saveConfirmText: 'Om du sparar nu kommer du rensa läshistoriken.',
      clearReadingHistory: 'Rensa läshistoriken',
      read: 'Läst',
      times: 'ggr',
      readingHistory: 'Läshistorik',
      readingHistoryInformation:
        'Om denna är ifylld så kommer läshistoriken rensas ifall en ny fil laddas upp.',
      noVenue: 'Tillhör ingen restaurang',
      new: 'Nytt Dokument',
      defaultName: 'namnlöst dokument',
      uploadText: 'Ladda upp eller släpp en fil som hör till dokumentet',
      link: 'Länk',
      fields: {
        name: 'Namn',
        description: 'Beskrivning',
        fileSrc: 'Fil',
        externalLink: 'Använd extern länk istället för att ladda upp fil',
      },
    },
    directory: {
      removeCurrent: 'Ta bort denna mapp',
      updateCurrent: 'Uppdatera denna mapp',
      dialogTitle: 'Mapp: ',
      name: 'Mapp',
      new: 'Ny Mapp',
      userPermitted: 'Tillåtna användare',
      chooseAll: 'Välj alla',
      fields: {
        name: 'Namn',
        description: 'Beskrivning',
        icon: 'Mappikon',
      },
      defaultName: 'namnlös mapp',
    },
  },
  'confirm.title': 'Är du säker?',
  resources: {
    documents: {
      name: 'Filer',
    },
    quizes: {
      name: 'Quiz |||| Quiz',
      fields: {
        prio: 'Prioritet',
        internalTitle: 'Rubrik (internt bruk)',
        buttonText: 'Text på startknapp',
        description: 'Beskrivning',
        active: 'Aktiv',
        market: 'Marknad',
        'promoImage.alt': 'Beskrivning av promotionbild',
        'promoImage.image': 'Promotionbild',
        checkpoint: 'Checkpoint',
        'checkpoints.amount': 'Antal frågor att ställa.',
        'checkpoints.title': 'Rubrik',
        'checkpoints.text': 'Beskrivning',
        'checkpoints.buttonText': 'Text på startknapp',
        'checkpoints.video': 'Video',
        'checkpoints.minCorrectAnswers': 'Antal rätta svar som krävs',
        'checkpoints.randomOrder': 'Slumpässig ordning',
        'checkpoints.question': 'Frågor',
        questions: 'Frågor',
        'questions.title': 'Fråga',
        'questions.time': 'Max antal sekunder',
        'questions.level': 'Nivå',
        'questions.correct': 'Rätt svar',
        'questions.options': 'Svarsalternativ',
        'questions.type': 'Frågetyp',
        'questions.isCorrect': 'Vilket är rätt svar',
        'questions.pair1': 'Första Paret',
        'questions.pair2': 'Andra Paret',
        'questions.pair3': 'Tredje Paret',
        'questions.category1Name': 'Namn på första kategorin',
        'questions.category1': 'Första kategorins innehåll',
        'questions.category2Name': 'Namn på andra kategorin',
        'questions.category2': 'Andra kategorins innehåll',
      },
      'checkpoints.removeConfirm': 'Är du säker på att du vill ta bort den här checkpointen?',
      'questions.removeConfirm': 'Är du säker på att du vill ta bort den här frågan?',
      'questions.singleSelect': 'Flervalsfråga (ett svar)',
      'questions.multipleSelect': 'Flervalsfråga (fler svar)',
      'questions.binary': 'Ja/Nej fråga',
      'questions.pair': 'Para ihop-övning',
      'questions.sort': 'Sorteringsövning (swipe)',
      'questions.imageSelect': 'Bildfråga',
      'questions.imageSelect.selectedTitle': 'Vald',
      'questions.imageSelect.selectedSubtitle': 'Denna bild kommer vara rätt svar på frågan.',
      'questions.imageSelect.correctHint':
        'Välj en bild nedan som är det rätta svaret på denna frågan.',
      'questions.imageSelect.optionsHint':
        'Ladda upp bilder som är svarsalternativ på denna frågan.',
      promoUpload:
        'Varje Quiz måste ha en promotion bild! Drag och släpp en fil för att ladda upp, eller klicka för att välja fil.',
      yes: 'Ja',
      no: 'Nej',
    },
    products: {
      name: 'Produkt |||| Produkter',
      fields: {
        submittedBy: 'Inlagd av',
        title: 'Rubrik',
        subtitle: 'Underrubrik',
        stations: 'Stationer',
        account: 'Konto',
        code: 'Kod',
        private: 'Kassaprodukt',
        unlockedBy: 'Upplåst av',
        markets: 'Marknader',
        mainImageUrl: 'Produktbild',
        gifImageUrl: 'Animerad gif',
        category: 'Kategori',
        types: 'Typer',
        diets: 'Dieter',
        allergens: 'Allergener (gamla)',
        provisionalImageUrl: 'Förslagsbild',
        alcoholic: 'Alkoholhaltig',
        readyToDrink: 'Ready-To-Drink',
        productContents: 'Innehåll',
        standardTaxCode: 'Standardmomskod (Norska produkter)',
        costPerPortion: 'Råvarupris per portion',
        recipes: 'Recept',
        ingredientList: 'Ingredienser',
        name: 'Namn',
        market: 'Prismarknad',
        updated: 'Uppdaterad',
        listOfContent: 'Innehållsdeklaration (gamla i fritext)',
        ingredients: 'Ingredienser (gamla i fritext)',
        ingredientsWithHint: 'Ingredienser med artikelnummer',
        instructions: 'Instruktioner',
        servingWeight: 'Serveringsvikt',
        servingPlatter: 'Serveras med / i / på:',
        mainCategory: 'Huvudkategori',
        internalName: 'Intern Benämning',
        suggestedPrice: 'Förslagspris',
        minPrice: 'Min. pris',
        maxPrice: 'Max. pris',
        contents: 'Innehållsdeklaration',
        'contents.supplier': 'Lev.namn',
        'contents.supplierOrderId': 'Best.nr',
        'contents.description': 'Namn',
        'contents.amount': 'Mängd',
        'contents.unit': 'Enhet',
        takeAwayEnabled: 'Take Away aktiverat',
        autoActivation: 'Automatisk aktivering (aktiveras dagligen, om pausad i sortiment)',
        takeAwayOnly: 'Take Away enbart, denna produkt kan ej användas i vanligt sortiment',
        venueWhitelist: 'Tillåtna restauranger',
        provisionalData: {
          state: 'Status',
          venues: 'Restauranger',
          discussion: 'Interna kommentarer',
        },
        downloadButton: 'Ladda ner bild',
        downloadInfo: 'Om bilden öppnas i nytt fönster, högerklicka - välj Spara som.',
        variablePrice: 'Produkten har ett flexibelt pris, används till fysiska presentkort i kassan',
      },
      productSheet: 'Produktblad',
      frozen: 'Vill du ta bort produkten ur samtliga sortiment? GÅR EJ ATT ÅNGRA',
    },
    'product-order': {
      name: 'Produktordning |||| Produktordning',
    },
    'frozen-products': {
      name: 'Frusen produkt |||| Frusna produkter',
      fields: {
        category: 'Kategori',
        internalName: 'Intern Benämning',
      },
    },
    faq: {
      name: 'Frågor & Svar |||| Frågor & Svar',
      fields: {
        identifier: 'Internt namn',
        question: 'Fråga',
        answer: 'Svar',
      },
    },
    'web-sites': {
      name: 'Webbplats |||| Webbplatser',
      fields: {
        name: 'Namn',
        market: 'Marknad',
      },
    },
    'web-pages': {
      name: 'Webbsida |||| Webbsidor',
      fields: {
        slug: 'URL slug',
        bannerTitle: 'Banner titel',
        metaContent: {
          title: 'Meta <title>',
          ogTitle: 'Meta <og:title>',
          description: 'Meta <description>',
        },
        headingBold: 'Bold Rubrik',
        headingThin: 'Thin Rubrik',
        video: 'Videolänk',
        videoPoster: 'Videoposter',
        backupImage: 'Backup-bild',
        heroImage: 'Hero bild',
        custom: 'Custom',
        blocks: 'Block',
        promos: 'Promos',
        website: 'Websida',
        'website.name': 'Websida',
      },
    },
    'web-promos': {
      name: 'Webbpromo |||| Webbpromos',
      fields: {
        internalName: 'Intern benämning',
        tag: 'Tag',
        headingBold: 'Rubrik - bold',
        headingThin: 'Rubrik - thin',
        image: 'Bild',
        button: {
          show: 'Visa',
          text: 'Text',
          internal: 'Intern',
          link: 'Länk',
        },
      },
    },
    recipes: {
      name: 'Recept |||| Recept',
      fields: {
        name: 'Namn',
      },
    },
    'provisional-products': {
      name: 'Produktförslag |||| Produktförslag',
      fields: {
        submittedBy: 'Inlagd av',
        title: 'Rubrik',
        subtitle: 'Underrubrik',
        stations: 'Stationer',
        mainImageUrl: 'Produktbild',
        market: 'Prismarknad',
        category: 'Kategori',
        allergens: 'Allergener',
        instructions: 'Instruktioner',
        mainCategory: 'Huvudkategori',
        provisionalData: {
          state: 'Status',
          venues: 'Restauranger',
          discussion: 'Interna kommentarer',
        },
        markets: {
          suggestedPrice: 'Förslagspris',
        },
        provisionalImageUrl: 'Förslagsbild',
        alcoholic: 'Alkoholhaltig',
        readyToDrink: 'Ready-To-Drink',
      },
    },
    'locked-products': {
      name: 'Standardprodukt |||| Standardprodukter',
    },
    'price-segments': {
      name: 'Prissegment',
    },
    'promoted-products': {
      name: 'Kampanjprodukt |||| Kampanjprodukter',
      fields: {
        category: 'Kategori',
        markets: 'Marknader',
        product: 'Produkt',
      },
    },
    allergens: {
      name: 'Allergen |||| Allergener',
      fields: {
        title: 'Rubrik',
        mainAllergen: 'Huvudallergen',
      },
    },
    diets: {
      name: 'Diet |||| Dieter',
      fields: {
        title: 'Rubrik',
      },
    },
    suppliers: {
      name: 'Leverantör |||| Leverantörer',
    },
    ingredients: {
      name: 'Ingrediens |||| Ingredienser',
      fields: {
        supplier: 'Leverantör',
        supplierOrderId: 'Leverantörens beställningsnummer',
        description: 'Namn',
        GTIN: 'GTIN',
        edible: 'Ätbar',
        originCountryCode: 'Ursprungsland',
        displayName: 'Namn i appen (ursprungsland)',
      },
    },
    categories: {
      name: 'Kategori |||| Kategorier',
      fields: {
        title: 'Rubrik',
        subtitle: 'Underrubrik',
        mainImageUrl: 'Kategoribild',
        mainCategory: 'Huvudkategori',
        description: 'Beskrivning',
        headerUrl: 'Länk till webbplats',
        scrollDirection: 'Vilket håll menyn scrollar åt',
      },
      horizontal: 'Åt sidan',
      vertical: 'Nedåt',
    },
    venues: {
      name: 'Restaurang |||| Restauranger',
      fields: {
        published: 'Publicerad',
        name: 'Namn',
        code: 'Kod',
        title: 'Rubrik',
        subtitle: 'Underrubrik',
        email: 'E-post',
        mobileNumber: 'Mobilnummer',
        visitationAddress: 'Besöksadress',
        'visitationAddress.addressLine1': 'Adress',
        'visitationAddress.city': 'Stad',
        'visitationAddress.zipCode': 'Postkod',
        'visitationAddress.country': 'Land',
        takeAwayVisitationAddress: 'Take Away Besöksadress',
        'takeAwayVisitationAddress.addressLine1': 'Take Away Adress',
        'takeAwayVisitationAddress.city': 'Take Away Stad',
        'takeAwayVisitationAddress.zipCode': 'Take Away Postkod',
        'takeAwayVisitationAddress.country': 'Take Away Land',
        loc: 'Position',
        'loc.coordinates': 'Position',
        'loc.coordinates[0]': 'Longitud',
        'loc.coordinates[1]': 'Latitud',
        'urls.jobApplication': 'Jobbansökan URL',
        'urls.facebook': 'Facebook-länk (webpage, editorial)',
        'urls.instagram': 'Instagram-länk (webpage, editorial)',
        'urls.woltUrl': 'Wolt-länk (editorial)',
        'urls.foodora': 'Foodora-länk (editorial)',
        'urls.npsOverride': 'Efterbesöksundersökning (NPS) överskrivning',
        'urls.selectionOverride': 'Skriv över var länkar till denna restaurang går',
        'openHours.locked': 'Låsta öppettider (super users kan redigera)',
        extOrderData: 'Extern Order data',
        'extData.externalId': 'Synkningsalternativ',
        'extOrderData.externalId': 'WSAB ID',
        appIdWhitelist: 'Publicerad',
        countryCode: 'Landskod',
        languageCode: 'Språkkod',
        organisationNumber: 'Organisationsnummer',
        customerId: 'Kund ID',
        franchiseGroup: 'Franchisegrupp',
        tipLimitFactor: 'Dricksgränsprocent',
        tipLimit: 'Dricksgräns',
        quickPayFactor: 'Snabbetalningsprocent (0 döljer snabbetalaknappen)',
        billingAllowed: 'Betalning tillåten',
        deliveryEnabled: 'Leverans',
        pickupEnabled: 'Upphämtning',
        supportedPSPs: 'Betalningsmetoder',
        takeAwayEnabled: 'Take Away aktiverat',
        creperieEnabled: 'Crepes & Galettes aktiverat',
        creperieTakeAwayEnabled: 'Crepes & Galettes Take Away aktiverat',
        autoActivation: 'Automatisk produktaktivering',
        orderStates: 'Orderstatusar',
        paynovaLocationId: 'Paynova plats-ID',
        paynovaMaxAmount: 'Paynova max-mängd',
        paynovaInvoiceMID: 'Paynova Merchant ID, Faktura',
        paynovaInvoiceMPW: 'Paynova Merchant Lösenord, Faktura',
        adyenMID: 'Adyen Merchant ID',
        adyenTerminalMID: 'Adyen Terminal Merchant ID (TapToPay)',
        swishMID: 'Swish Merchant ID',
        vippsMID: 'Vipps Merchant ID',
        tableBooking: 'Bordsbokning',
        'tableBooking.href': 'Bordsbokninglänk',
        'tableBooking.overrideHref': 'Överskrivande bordsbokninglänk',
        'tableBooking.googleBookingEnabled': 'Google Booking',
        isOpen: 'Är öppen',
        'reordering.message': 'Beställningspåminnelse',
        'reordering.timeout': 'Schemalägg påminnelse (sekunder)',
        products: 'Produkter',
        market: 'Marknad',
        placeId: 'Restaurang IDs',
        'it.operations': 'IT-drift',
        'it.primaryNetwork': 'Primär fiberleverantör',
        'it.backupNetwork': 'Reserv fiberleverantör',
        'it.printerServer': 'Skrivarserver',
        classifications: 'Klassifikation',
        xSale: 'X-Sale',
        ratings: 'Visa NKI',
        area: 'Område',
        showGuestFeedback: 'Visa återkopplingsdialog vid dålig feedback',
      },
    },
    assortments: {
      name: 'Sortiment |||| Sortiment',
      fields: {
        published: 'Publicerad',
        name: 'Namn',
        code: 'Kod',
        title: 'Rubrik',
        subtitle: 'Underrubrik',
        email: 'E-post',
        mobileNumber: 'Mobilnummer',
        visitationAddress: 'Besöksadress',
        'visitationAddress.addressLine1': 'Adress',
        'visitationAddress.city': 'Stad',
        'visitationAddress.zipCode': 'Postkod',
        'visitationAddress.country': 'Land',
        loc: 'Position',
        'loc.coordinates': 'Position',
        'loc.coordinates[0]': 'Longitud',
        'loc.coordinates[1]': 'Latitud',
        'urls.jobApplication': 'Jobbansökan URL',
        extOrderData: 'Extern Order data',
        'extData.externalId': 'Synkningsalternativ',
        'extOrderData.externalId': 'WSAB ID',
        appIdWhitelist: 'Publicerad',
        countryCode: 'Landskod',
        languageCode: 'Språkkod',
        tipLimitFactor: 'Dricksgränsprocent',
        tipLimit: 'Dricksgräns',
        quickPayFactor: 'Snabbetalningsprocent (0 döljer snabbetalaknappen)',
        billingAllowed: 'Betalning tillåten',
        deliveryEnabled: 'Leverans',
        pickupEnabled: 'Upphämtning',
        supportedPSPs: 'Betalningsmetoder',
        orderStates: 'Orderstatusar',
        paynovaLocationId: 'Paynova plats-ID',
        paynovaMaxAmount: 'Paynova max-mängd',
        tableBooking: 'Bordsbokning',
        'tableBooking.href': 'Bordsbokninglänk',
        isOpen: 'Är öppen',
        'reordering.message': 'Beställningspåminnelse',
        'reordering.timeout': 'Schemalägg påminnelse (sekunder)',
        products: 'Produkter',
        market: 'Marknad',
      },
    },
    'product-activation': {
      name: 'Aktiv produkt |||| Aktiva produkter',
    },
    phrases: {
      name: 'Fras |||| Fraser',
      fields: {
        identifier: 'Identifikator',
        translations: 'Översättningar',
        notes: 'Anteckningar (kontext)',
      },
    },
    markets: {
      name: 'Marknad |||| Marknader',
      fields: {
        title: 'Rubrik',
      },
    },
    stations: {
      name: 'Station |||| Stationer',
      fields: {
        title: 'Rubrik',
        name: 'Unikt namn',
      },
    },
    psps: {
      name: 'PSP |||| PSP:er',
      fields: {
        name: 'Namn',
        active: 'Aktiv',
        account: 'Konto',
      },
    },
    users: {
      name: 'Användare |||| Användare',
      fields: {
        username: 'Användarnamn',
        mobileNumber: 'Mobilnummer',
        email: 'E-post',
        avatar: 'Foto',
        role: 'Roll',
        position: 'Position',
        venues: 'Restauranger',
        market: 'Primär marknad',
        languages: 'Översättare för språk',
        area: 'Välj ett område enbart om användaren är en Area Manager',
      },
    },
    positions: {
      name: 'Arbetsposition |||| Arbetspositioner',
      fields: {
        identifier: 'Identifikator',
        name: 'Namn',
      },
    },
    'booking-users': {
      name: 'Booking-användare |||| Booking-användare',
      fields: {
        username: 'Användarnamn',
        password: 'Lösenord',
        placeId: 'Places',
      },
    },
    roles: {
      name: 'Roll |||| Roller',
      fields: {
        resources: 'Resurser',
        subRoles: 'Underroller',
        superUser: 'Super Användare',
        translator: 'Översättare',
        priceEditor: 'Prisredigerare',
        priceManager: 'Prisadministratör',
      },
    },
    'tiered-products': {
      name: 'Rankade produkter',
    },
    tieredProducts: {
      t1: 'Bra',
      t2: 'Bättre',
      t3: 'Bäst',
      red: 'Rött vin',
      white: 'Vitt vin',
      rose: 'Rosé',
      sparkling: 'Bubbel',
    },
    academy: {
      name: 'Pinchoversity |||| Pinchoversity',
    },
    students: {
      name: 'Studenter |||| Studenter',
    },
    courses: {
      name: 'Kurser |||| Kurser',
      fields: {
        evaluationForm: 'Länk till Google Formulär',
      },
    },
    news: {
      name: 'Nyheter |||| Nyheter',
      fields: {
        areas: 'Områden',
        markets: 'Marknader',
        positions: 'Positioner',
        enableNotification:
          'Skicka ut ett SMS om nyheten. Det kommer skickas till alla användare i katalogen. Om du väljer en position kommer det skickas till alla användare som har den positionen.',
      },
      amountOfUsersNotification: 'Du kommer skicka SMS till: ',
      users: 'användare',
      smsCost: 'Det kommer kosta: ',
      notificationMessage: 'Skriv ditt SMS här',
      smsSuccess: 'Det funkade!',
      smsError: 'Någonting gick fel.',
      sendSMS: 'Skicka SMS',
      openSMSDialog: 'Öppna SMS-hanterare',
      noEmptyBody: 'Ditt SMS får inte vara tomt.',
      alreadyNotified: 'Denna nyhet har blivit utskickad tidigare.',
      selectPositionNotification:
        'Om du väljer en position kommer det skickas ut till alla användare som har den positionen.',
      smsDelay: 'Det kan ta upp till 12 minuter innan SMS:en faktiskt skickas.',
    },
    courseCategory: {
      name: 'Kategori |||| Kategorier',
    },
    books: {
      name: 'E-learning |||| E-learning',
    },
    alias: {
      name: 'Alias |||| Alias',
      type: 'Typ',
      enterType: 'Ange Typ',
      alias: 'Alias',
      similar: 'Liknande',
      enterAlias: 'Ange Alias',
      chooseProduct: 'Välj Produkt',
      errorText: 'Endast ett produktnamn i taget. Kan inte vara "food" eller "drink".',
      add: 'Lägg till',
    },
    egghunt: {
      name: 'Äggjakten',
    },
    accountingPlans: {
      fields: {
        categories: 'Kategorier',
        psps: 'Betalningsleverantörer',
      },
    },
    accounts: {
      fields: {
        name: 'Namn',
        market: 'Marknad',
        defaultId: 'Standardvärde',
        type: 'Typ',
        text: 'Text',
      },
    },
    'accounting-plans': {
      headers: {
        incoming: 'Inkommande',
        outgoing: 'Utgående',
      },
      fields: {
        'acc-name': 'Kontonamn',
        'acc-type': 'Kontotyp',
        'acc-number': 'Kontonummer',
      },
    },
  },
  markets: {
    countryCode: 'Landskod',
    vat: 'Momssats (0-100)',
    suggestedPrice: 'Förslagspris',
    discountable: 'Rabatterbar produkt?',
    overrideMainImageUrl: 'Ersätt produktbilden för denna marknad',
    consumesLoyalty: 'Använder bonuspoäng',
    producesLoyalty: 'Ger bonuspoäng',
    ignorePriceSegment: 'Eget prisintervall',
  },
  'edit.title': 'Ändra "%{title}"',
  validate: 'Validera',
  unpublish: 'Spara och Avpublicera',
  unpublishConfirm: 'Är du säker att du vill avpublicera',
  publish: 'Spara och Publicera',
  activateSync: 'Aktivera synkning',
  food: 'Mat',
  drink: 'Dryck',
  paynova: 'Paynova',
  paynovainvoice: 'Paynova faktura',
  paynova3ds: 'Paynova 3D Secure',
  cash: 'Kontant',
  free: 'Gratis',
  vipps: 'Vipps',
  swish: 'Swish',
  selectAll: 'Markera alla',
  deselectAll: 'Avmarkera alla',
  hideLocked: 'Dölj standardprodukter',
  showLocked: 'Visa standardprodukter',
  info: 'Info',
  payment: 'Betalning',
  productManagement: 'Produktkatalog',
  clone: 'Klona',
  close: 'Stäng',
  lockedPrice: 'Låst pris',
  start: 'Start',
  end: 'Avslut',
  'data.start': 'Start',
  'data.end': 'Avslut',
  selectMarket: 'Välj marknad',
  thisCantBeChanged: 'Detta ändras senare',
  promoteToMainImage: 'Gör till produktbild',
  recipeCreated: 'Recept skapat!',
  recipeAdded: 'Recept tillagt!',
  recipeIngredientsUpdated: 'Receptets ingredienser uppdaterade!',
  recipe: 'Recept',
  recipeName: 'Receptnamn',
  newRecipe: 'Nytt Recept',
  existingRecipe: 'Existerande Recept',
  add: 'Lägg till',
  cancel: 'Avbryt',
  submit: 'Spara',
  edit: 'Redigera',
  remove: 'Ta bort',
  login: 'Inloggning',
  contact: 'Kontakt',
  subscriptions: 'Prenumerationer',
  emailSubscriptions: 'E-post prenumerationer',
  missingTranslations: 'Saknad översättning |||| Saknade översättningar',
  codeHint: 'Lämna tom för autogenererad kod',
  internalNameHint:
    'Unik text som används internt för att identifiera produkten, alltid på engelska, lämplig benämning är exempelvis "Cheeseburger Bacon Heden"',
  filledAfterSave: 'Dessa fält ifylls efter ni sparat produkten!',
  publishMessages: {
    noTitleProvided: 'Ingen rubrik angiven',
    noSubTitleProvided: 'Ingen underrubrik angiven',
    noCodeProvided: 'Ingen kod angiven',
    noCoordinatesProvided: 'Koordinater saknas',
    noProductsChosen: 'Inga produkter valda',
    noAddressProvided: 'Ingen adress angiven',
    noCityProvided: 'Ingen stad angiven',
    noZipCodeProvided: 'Inget postnr angivet',
    noCountryProvided: 'Inget land angivet',
    invalidUrl: 'URL is not valid',
    noPaymentMethods: 'Inga betalmetoder aktiva',
    syncDisabled: 'Synkning inaktiv',
    invalidTableBookingLink: 'Felaktig bokningslänk',
    noStations: 'Inga stationer valda',
    noValidMarkets: 'Ingen giltig marknad',
    invalidMarkets: 'En eller fler ogiltiga marknader',
    noImage: 'Ingen bild',
    noAllergens: 'Inga allergener (gamla) valda',
  },
  academy: {
    academy: 'Academy',
    pinchoversity: 'Pinchoversity',
    bookTitle: 'boktitel',
    book: 'Bok',
    books: 'Böcker ',
    chapter: 'Kapitel',
    chapters: 'Kapitel',
    page: 'Sida',
    pages: 'Sidor',
    question: 'Fråga',
    questions: 'Frågor',
    genre: 'Genre',
    studentFetchError: 'Vi kunde inte hitta din studentinformation! Försök igen senare!',
    booksFetchError: 'Vi kunde inte hitta dina böcker! Försök igen senare!',
    quizValidationError: 'Kunde tyvärr inte rätta din quiz nu! Försök igen senare!',
    course: 'Kurs',
    courses: 'Kurser',
    'course.readMore': 'Ta Kurs',
    'book.readMore': 'Läs',
    courseMoment: 'Kurstillfälle',
    courseMoments: 'Kurstillfällen',
    teacher: 'Lärare',
    attendees: 'Deltagare',
    maxAttendees: 'Antal deltagare',
    address: 'Adress',
    city: 'Stad',
    lastRegistrationDate: 'Sista registreringstillfället',
    courseRegistration: 'Kursanmälan',
    registrationFullMessage: 'Det finns inte tillräckligt med plats på kursen.',
    registrationEmptyMessage: 'Välj någon från listan för att registrera dem på kursen.',
    alreadyRegisteredMessage: 'är redan registrerad på kursen.',
    'alreadyRegisteredMessage.pl': 'är redan registrerade på kursen.',
    startDate: 'Startdatum',
    endDate: 'Avslutdatum',
    openSpots: 'Lediga Platser',
    register: 'Anmäl',
    description: 'Beskrivning',
    newsPublishSuccess: 'Din nyhet har blivit publicerad!',
    newsPublishFailure: 'Din nyhet kunde tyvärr inte bli publicerad',
    registeredCourses: 'Registrerade Kurser',
    completedCourses: 'Kursintyg',
    registerComments: 'Kommentarer, t.ex. allergier, dieter, önskemål, etc.',
    invite: 'Bjud In',
    introBlurb:
      'Hej och välkommen till Pinchoversity! Här kan du hitta utbildningar, både som e-learning som du kan ta i din mobil och lärarledda kurstillfällen att anmäla sig till. En del är obligatoriska för alla våra medarbetare i kedjan och en del är fortsättningskurser. Klicka vidare för att se vad du kan lära dig mer om.',
    elearningBlurb:
      'Hej här hittar du våra e-learning böcker. Varje kurs innehåller dels text, dels videos, varje kapitel avslutas med lite kontrollfrågor. När du klarat alla kontrollfrågor har du klarat kursen. Du kan hitta vilka kurser du klarat under din profil. Lycka till. All feedback är välkommen och skickas till linda.holm@pinchos.se',
    coursesBlurb:
      'Hej här hittar du de lärarledda kurser vi erbjuder. Under varje kurs hittar du planerade kurstillfällen och vart kursen äger rum. Restaurangchefen är den som anmäler vilka det är som ska deltaga.',
    elearningSpan: 'kommer snart',
    coursesSpan: 'hitta kurstillfällen och gör en anmälan',
    startTime: 'Starttid',
    endTime: 'Sluttid',
    takeCourse: 'Ta kursen',
    moreInfo: 'Mer information',
    elearning: 'E-learning',
    continue: 'Fortsätt',
    teacherLedCourses: 'Lärarledda Kurser',
    registerSuccessBlurb: 'Tack för anmälan, du och din personal hittar den under er profil.',
    noRegisteredCourses: 'Du är inte registrerad på några kurser',
    coursesLink: 'Klicka här för att hitta kurser!',
    continueTo: 'Fortsätt till',
    correctMessage: 'Meddelande om man svarar rätt',
    incorrectMessage: 'Meddelande om man svarar fel',
    courseCategory: 'Kategori',
    pageTitle: 'Sidtitel',
    chapterEnd: 'Slut på kapitlet',
    courseDoneBlurb: 'Kursen är avklarad!',
    congratulations: 'Grattis!',
    noCourseMomentsBlurb: 'Inga planerade kurstillfällen för närvarande.',
    welcome: 'Välkommen till ',
    completedElearning: 'Avklarade Elearningkurser',
    chapterCompleted: 'Grattis! Du klarade kapitlet! Klicka på knappen nedan för att gå vidare!',
    theEnd: 'Klart',
    quizFetchError: 'Kunde inte spara dina resultat.',
    blankFields: 'Fyll i alla fälten',
    courseOverview: 'Kursöversikt',
    confirmDeleteCourseMoment: 'Är du säker på att du vill ta bort kurstillfälle: ',
    deleteAttendeeParty: 'Ta bort gruppen',
    confirmDeleteParty: 'Är du säker på att du vill ta bort gruppen: ',
    removeCourseMoment: 'Ta bort kurstillfälle',
    venue: 'Restaurang',
    noDefaultVenueMessage:
      'Du måste ha en förvald restaurant för att kunna anmäla deltagare till kurser.',
    unRegister: 'Avregistrera',
    coursesSuccessMessage: 'Grattis! Du klarade kursen!',
  },
  website: {
    header: 'Formattering',
    header1: 'Rubrik 1',
    header2: 'Rubrik 2',
    header3: 'Rubrik 3',
    header4: 'Rubrik 4',
    headingText: 'Rubriktext',
    bodyText: 'Brödtext',
    size: 'Storlek',
    show: 'Visa',
    androidLink: 'Android Länk',
    giftcardTemplateId: 'Presentkortsmall ID',
    iosLink: 'iPhone Länk',
    imageWide: 'Bred Bild',
    imageSquare: 'Fyrkantig Bild',
    imageUrl: 'Bildlänk',
    appPromotion: 'Appkampanj',
    standardLayout: 'Standardlayout',
    textAlign: 'Textjustering',
    buttonText: 'Knapptext',
    link: 'Länk',
    alt: 'Alt text (text som syns om bilden inte kan laddas samt för skärmavläsare)',
    internal: 'Intern länk (navigering)',
    blockHeading: 'Blockets rubrik',
    blockCopy: 'Blockets brödtext',
    blockImage: 'Blockets bild',
    blockButton: 'Blockets knapp (lämnas tom för att inte ha en knapp)',
    blocks: {
      name: 'Block',
      imageAndText: 'Bild med text',
      heading: 'Rubrik',
      button: 'Knapp',
      faq: 'Frågor & Svar',
      image: 'Bild',
      text: 'Brödtext',
      youtube: 'YouTube video',
      contactForm: 'Kontaktformulär',
    },
  },
  menuTitles: {
    products: 'Produkt',
    users: 'Användare',
    academy: 'Pinchoversity',
    vip: 'VIP Innehåll',
    accounting: 'Konton',
  },
  news: {
    news: 'Nyheter',
    'news.sg': 'Nyhet',
    post: 'Publicera',
    north: 'Nordöst',
    south: 'Sydväst',
    central: 'PN',
    'load-older': 'Ladda äldre nyheter',
  },
  statistics: {
    title: 'Statistik',
    selectMarket: 'Välj Marknad',
    selectArea: 'Välj Område',
    north: 'Nordöst',
    south: 'Sydväst',
    central: 'PN',
    products: 'Produkter',
    allProducts: 'Alla Produkter',
    categories: 'Kategorier',
    defaultProducts: 'Standardprodukter',
    venues: 'Restauranger',
    allVenues: 'Alla Restauranger',
    area: 'Område',
    cluster: 'Kluster',
    fetchingData: 'Hämtar data...',
    downloadCSV: 'Ladda ner som CSV',
    query: 'Sök',
    selected: 'valda',
    selectCategory: 'Välj Kategori',
    coastal: 'Kuststad',
    city: 'Storstad',
    period: 'Period',
    daily: 'Dagligen',
    weekly: 'Veckovis',
    monthly: 'Månadsvis',
    quarterly: 'Kvartalsvis',
    yearly: 'Årsvis',
    minutewise: 'Minutvis',
    hourly: 'Timvis',
    selectCluster: 'Välj Kluster',
    date: 'Datum',
    interval: 'Intervall',
    from: 'Från',
    to: 'Till',
    SE: 'Sverige',
    DK: 'Danmark',
    NO: 'Norge',
    FI: 'Finland',
    DE: 'Tyskland',
    UK: 'Storbrittanien',
    guests: 'Gäster',
    allBookingsTypes: 'Alla typer',
    booked: 'Bokade',
    cancelled: 'Avbokade',
    noShow: ' No shows',
    denied: 'Nekade',
    dropIns: 'Drop ins',
    seatingDate: 'Sittningsdatum',
    bookingDate: 'Bokningsdatum',
    bookingType: 'Bokningstyp',
    dateType: 'Typ av datum',
    'ort>50k': 'Ort > 50k',
    'ort<50k': 'Ort < 50k',
    sales: 'Försäljning',
    guestsAmount: 'Gästantal',
    sameStoreSales: 'Lika för Lika',
    drinks: 'Dryck',
    food: 'Mat',
  },
  translations: {
    translatable: 'Translatable',
    referenceLanguage: 'Referensspråk',
    SE: 'Sverige',
    DK: 'Danmark',
    NO: 'Norge',
    FI: 'Finland',
    DE: 'Tyskland',
    UK: 'Storbrittanien',
  },
  diploma: {
    download: 'Ladda ner ditt diplom',
  },
  languages: {
    sv: 'Svenska',
    en: 'Engelska',
    nb: 'Norska',
    da: 'Danska',
    fi: 'Finska',
    de: 'Tyska',
    es: 'Spanska',
  },
  errors: {
    'save-failed': 'Sparande misslyckades, anledning: ',
    'fetch-failed': 'Hämtning misslyckades, anledning: ',
  },
  'save-success': 'Sparat!',
  show: 'Visa',
  reason: 'Anledning',
  feedback: 'Feedback',
  searchNewValue: 'Sök efter nytt värde',
  currentValue: 'Nuvarande värde',
  searchAndSetOverride: 'Sök efter värde för överskrivning',
  currentMarketValue: 'Marknadens värde',
  reset: 'Återställ',
  price: 'Pris',
  noPriceSetMsg: 'Inget pris satt',
  onlyDeactivateMsg: 'Saknar marknadspris, kan endast bli inaktiverad',
  missingMin: 'Priset kan inte ändras pga saknat Min. pris',
  missingMax: 'Priset kan inte ändras pga saknat Max. pris',
  missingMinAndMax: 'Priset kan inte ändra pga saknat Min. och Max. pris',
  valueNotInRange: 'Värdet är för högt eller lågt',
  save: 'Spara',
  undefined: 'undefined',
  search: 'Sök efter %{queryables}',
  name: 'Namn',
  email: 'Email',
  categories: 'kategorier',
  permissions: 'Rättigheter',
  organisation: 'Organisation',
  restaurantManager: 'Restaurangchef',
  steward: 'Hovmästare',
  waiter: 'Servis',
  barManager: 'Baransvarig',
  bartender: 'Bartender',
  chef: 'Köksmästare',
  sousChef: 'Sous chef',
  cook: 'Kock',
  dishwasher: 'Diskare',
  prospect: 'Prospekt',
  franchisees: 'Franchisetagare',
  areaManager: 'Area manager',
  socialMediaManager: 'Sociala medier ansvarig',
  economy: 'Ekonomi',
  userFoundWithNumber: 'Hittade användare med nummer %{phoneNumber}!',
  userHasPosition: 'Användare har redan denna position!',
  userNotFoundFillForm: 'Ingen användare hittad, fyll i nedan',
  from: 'från',
  for: 'för',
  fullName: 'Namn & efternamn',
  phoneNumber: 'Telefonnummer',
  referenceNumber: 'Anställningsnummer',
  referenceNumberRequired: 'Anställningsnummer är obligatoriskt',
  nameIsRequired: 'Namn är obligatoriskt',
  emailIsRequired: 'Email är obligatoriskt',
  query: 'Sök',
  places: 'Restauranger',
  'create.item': 'Skapa %{item}',
  readMore: 'Läs mer',
  allLanguages: 'Alla Språk',
  'edit.item': 'Redigera %{item}',
  home: 'Hem',
  title: 'Rubrik',
  textBody: 'Textinnehåll',
  language: 'Språk',
  option: 'Alternativ',
  correct: 'Rätt',
  incorrect: 'Fel',
  icon: 'Ikon',
  back: 'Bakåt',
  previous: 'Föregående',
  next: 'Nästa',
  'previous.item': 'Föregående %{item}',
  'next.item': 'Nästa %{item}',
  globalSettings: 'Pinchos övergripande inställningar',
  globalPspCaption: 'PSP kill switch',
  tag: 'Kategori',
  tags: 'Kategorier',
  answer: 'Svar',
  position: 'Position',
  positionsHintText: 'Välj vem som kan se innehållet. Lämna den tom om alla ska kunna se det.',
  swedish: 'Svenska',
  english: 'Engelska',
  helpdesk: 'Driftstatus',
  marketingPortal: 'Marknadsportal',
  booking: 'Bokning',
  jobs: 'Lediga Jobb',
  'choose.item': 'Välj %{item}',
  file: 'Fil',
  'hide.item': 'Göm %{item}',
  'show.item': 'Visa %{item}',
  comments: 'Kommentarer',
  import: 'Import',
  export: 'Export',
  updated: 'Uppdaterad',
  perPage: 'Per Sida',
  all: 'Alla',
  created: 'Skapad',
  and: 'och',
  edited: 'redigerad',
  others: 'Övrigt',
  date: 'Datum',
  goToProfile: 'Se Profil',
  externalLinks: 'Externa länkar',
  Price: 'Pris',
  subtitle: 'Underrubrik',
  games: 'Säljtävling',
  'booking-settings': 'Bokningsinställningar',
  unauthorizedHeader: 'Du har inte tillåtelse att se denna sida!',
  unauthorizedText: 'Kontakta din Restaurangchef eller Area Manager för mer information.',
  print: 'Skriv ut',
  venues: 'Restauranger',
  activeVenues: 'Aktiva Restauranger',
  market: 'Marknad',
  venue: 'Restaurang',
  articleGroups: 'Artikelgrupp',
  missingContents: 'Saknar innehåll',
  reimbursement: 'Återbetalning',
  'marketing-material': 'Marknadsmaterial',
  'catalog-title': 'Pinchos Katalog',
  bireports: 'BI Rapport',
  open: 'Öppet',
  openingHour: 'Öppningstid',
  closingHour: 'Stängningstid',
  timezone: 'Tidszon',
  openHours: 'Öppettider',
  late: 'Sent',
  'provisional-products.preliminary-form': 'Fyll detta formulär innan du går vidare:',
  'pn-contact': 'PN Kontakt',
  'assortment-moved-title': 'Produktaktivering har flyttats',
  'assortment-moved-text': 'All aktivering och pausning görs nu via Restaurant Sortiment. Denna förändring tar bort fördröjningen mellan att något pausas eller aktiveras och att det försvinner eller dyker upp i appen. Utöver detta får gäster även en tydlig notifikation om de försöker beställa en produkt som pausats.',
  'organisation-moved-title': 'Organisationsträdet har flyttats',
  'organisation-moved-text': 'Organisationsträdet finns nu i Restaurant.',
  'news-moved-title': 'Nyheter har flyttats',
  'news-moved-text': 'Nyheter finns nu i Workplace.',
};
